import { MessageBox, Message } from 'element-ui'
import i18n from "@/i18n/i18n";


export const toTreeData = (data, attributes) => {

  let resData = [].concat(data);
  let tree = [];

  for (let i = 0; i < resData.length; i++) {
    if (resData[i].parentId === attributes.rootId) {
      let obj = {
        id: resData[i][attributes.id],
        label: resData[i][attributes.name],
        url: resData[i][attributes.url],
        value: resData[i][attributes.value],
        image: resData[i][attributes.image],
        idPath: [resData[i][attributes.id]],
        status: [resData[i][attributes.status]]
      };
      tree.push(obj);
      resData.splice(i, 1);
      i--;
    }
  }
  run(tree);

  function run(chiArr) {
    if (resData.length !== 0) {
      for (let i = 0; i < chiArr.length; i++) {
        for (let j = 0; j < resData.length; j++) {
          if (chiArr[i].id === resData[j][attributes.parentId]) {
            let temp = chiArr[i].idPath.concat([resData[j][attributes.id]]);
            let obj = {
              id: resData[j][attributes.id],
              label: resData[j][attributes.name],
              url: resData[j][attributes.url],
              value: resData[j][attributes.value],
              image: resData[j][attributes.image],
              idPath: temp,
              status: [resData[j][attributes.status]]
            };

            if (!chiArr[i].hasOwnProperty("children")) {
              chiArr[i].children = [];
            }
            chiArr[i].children.push(obj);
            resData.splice(j, 1);
            j--;
          }
        }
        if (chiArr[i].hasOwnProperty("children")) {
          run(chiArr[i].children);
        }
      }
    }
  }

  return tree;
};

export const successInfo = (msg = "common.operate_success") => {
  Message.success({
    message: i18n.t(msg)
  });
};

export const errorInfo = (msg = "common.operate_fail") => {
  Message.error({
    message: i18n.t(msg)
  });
};

export const cancelInfo = (msg = "common.cancel_operate_text") => {
  Message.info({
    message: i18n.t(msg)
  });
};

export const successBox = (msg = "common.operate_success", callback = () => {}) => {
  MessageBox.alert(i18n.t(msg), i18n.t("common.system_warn"), {
    confirmButtonText: i18n.t("common.ok_text"),
    type: "success",
    center: true,
    callback: callback
  });
};

export const errorBox = (msg = "common.operate_fail", callback = () => {}) => {
  MessageBox.alert(i18n.t(msg), i18n.t("common.system_warn"), {
    confirmButtonText: i18n.t("common.ok_text"),
    type: "error",
    center: true,
    callback: callback
  });
};

export const confirmBox = (msg = i18n.t("common.confirm_continue_text"), success = () => {}, cancel = () => {}) => {
  MessageBox.confirm(msg, i18n.t("common.system_warn"), {
    confirmButtonText: i18n.t("common.ok_text"),
    cancelButtonText: i18n.t("common.cancel_text"),
    type: "warning",
    center: true,
    closeOnClickModal: false,
    closeOnPressEscape: true
  })
    .then(success)
    .catch(() => {
      cancelInfo(i18n.t("common.cancel_operate_text"));
      cancel();
    });
};

export const alertBox = ( msg = i18n.t("common.confirm_continue_text"), success = () => {},) => {
  MessageBox.alert(msg, i18n.t("common.system_warn"), {
    confirmButtonText: i18n.t('common.ok_text'),
    type: 'error',
    center: true,
    callback: success
  })
};

// localStorage
export function getItem(item) {
  return window.localStorage.getItem(item)
}

export function setItem(item, value) {
  return window.localStorage.setItem(item, value)
}

export function removeItem(item){
  return window.localStorage.removeItem(item)
}

export function clearItem() {
  return window.localStorage.clear()
}

// sessionStorage
export function getSessionItem(item) {
  return window.sessionStorage.getItem(item)
}

export function setSessionItem(item, value) {
  return window.sessionStorage.setItem(item, value)
}

export function removeSessionItem(item){
  return window.sessionStorage.removeItem(item)
}

export function clearSessionItem() {
  return window.sessionStorage.clear()
}